import { render, staticRenderFns } from "./LayoutWithHeader.vue?vue&type=template&id=1b9f7f99"
import script from "./LayoutWithHeader.vue?vue&type=script&lang=js"
export * from "./LayoutWithHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports